// eslint-disable-next-line import/prefer-default-export
// eslint-disable-next-line import/prefer-default-export

export const SHOP_TABS = [
  {
    name: '상품정보',
    value: 'information'
  },
  {
    name: '고객후기',
    value: 'reviews'
  }
];
